var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.legend))]),_vm._l((_vm.filteredFields),function(field,name){return _c('FieldWrap',{key:name,attrs:{"fieldName":name,"fieldData":field}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }